var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","color":"red","x-small":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"color":"white","dark":"","small":""}},[_vm._v(" mdi-close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }